import { SVGProps } from 'react';

export const TaskListFolderImage = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="64"
      height="60"
      viewBox="0 0 64 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path
            d="M4 8C4 3.58172 7.58172 0 12 0H35.3563C37.7036 0 39.6063 1.90279 39.6063 4.25C39.6063 6.59721 41.5091 8.5 43.8563 8.5H52C56.4183 8.5 60 12.0817 60 16.5L60 64H4V8Z"
            fill="white"
          />
          <path
            d="M38.6064 4.25C38.6064 2.45511 37.1513 1.00006 35.3564 1H12C8.13401 1 5 4.13401 5 8V63H59V16.5C59 12.634 55.866 9.5 52 9.5H43.8564C40.957 9.5 38.6064 7.14949 38.6064 4.25ZM39.6123 4.46875C39.7225 6.64186 41.4646 8.384 43.6377 8.49414L43.8563 8.5H52C56.4183 8.5 60 12.0817 60 16.5L60 64H4V8C4 3.58172 7.58172 0 12 0H35.3563L35.5752 0.00585938C37.7482 0.116095 39.4904 1.8582 39.6006 4.03125L39.6123 4.46875Z"
            fill={`url(#paint0_${props.id})`}
          />
          <path
            d="M11 27.5C11 26.1193 12.1193 25 13.5 25H50.5C51.8807 25 53 26.1193 53 27.5C53 28.8807 51.8807 30 50.5 30H13.5C12.1193 30 11 28.8807 11 27.5Z"
            fill={`url(#paint1_${props.id})`}
          />
          <path
            d="M11 9C11 6.79086 12.7909 5 15 5H29C31.2091 5 33 6.79086 33 9V16C33 18.2091 31.2091 20 29 20H15C12.7909 20 11 18.2091 11 16V9Z"
            fill={`url(#paint2_${props.id})`}
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={`paint0_${props.id}`}
          x1="40"
          y1="-14.5"
          x2="18.5"
          y2="67.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="0.780666" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`paint1_${props.id}`}
          x1="32"
          y1="25"
          x2="32"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id={`paint2_${props.id}`}
          x1="22"
          y1="5"
          x2="22"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <clipPath id={`clip0_${props.id}`}>
          <rect width="64" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
